/**
 * AUTO-GENERATED — do not edit by hand.
 * Run `npm run generate:content-pack` (or this script directly).
 * Source: validated content pack enemy definitions, sorted by id.
 */
export const ENEMY_DEFINITION_ORDER: readonly string[] = ["enemy.gunTower","enemy.lootTruck","enemy.quaternius.alien","enemy.quaternius.alien-high-detail","enemy.quaternius.alien-high-detail.boss","enemy.quaternius.alpaking","enemy.quaternius.alpaking-evolved","enemy.quaternius.armabee","enemy.quaternius.armabee-evolved","enemy.quaternius.birb","enemy.quaternius.blue-demon","enemy.quaternius.bunny","enemy.quaternius.cactoro","enemy.quaternius.cactoro-high-detail","enemy.quaternius.cactoro-high-detail.boss","enemy.quaternius.cat","enemy.quaternius.chicken","enemy.quaternius.demon","enemy.quaternius.demon-high-detail","enemy.quaternius.demon-high-detail.elite","enemy.quaternius.dino","enemy.quaternius.dragon","enemy.quaternius.dragon-evolved","enemy.quaternius.fish","enemy.quaternius.fish-high-detail","enemy.quaternius.fish-high-detail.boss","enemy.quaternius.frog","enemy.quaternius.ghost","enemy.quaternius.ghost-skull","enemy.quaternius.glub","enemy.quaternius.glub-evolved","enemy.quaternius.goleling","enemy.quaternius.goleling-evolved","enemy.quaternius.green-blob","enemy.quaternius.green-spiky-blob","enemy.quaternius.hywirl","enemy.quaternius.monkroose","enemy.quaternius.mushnub","enemy.quaternius.mushnub-evolved","enemy.quaternius.mushroom-king","enemy.quaternius.ninja","enemy.quaternius.ninja-high-detail","enemy.quaternius.ninja-high-detail.boss","enemy.quaternius.orc","enemy.quaternius.orc-enemy","enemy.quaternius.pigeon","enemy.quaternius.pink-blob","enemy.quaternius.squidle","enemy.quaternius.tribal","enemy.quaternius.wizard","enemy.quaternius.yeti","enemy.quaternius.yeti-high-detail","enemy.quaternius.yeti-high-detail.elite","enemy.rammer","enemy.scrapBug","enemy.scrapBugHorde","enemy.testHound"];
/** Deterministic hash of the sorted definition order (protocol gate). */
export const ENEMY_DEFINITION_ORDER_HASH = '12536e7291afc7064fc8e8d8ae7801c4f03efe973b332ed1e4309f59328d247f';
export const ENEMY_DEFINITION_INDEX: Readonly<Record<string, number>> = {
  "enemy.gunTower": 1,
  "enemy.lootTruck": 2,
  "enemy.quaternius.alien": 3,
  "enemy.quaternius.alien-high-detail": 4,
  "enemy.quaternius.alien-high-detail.boss": 5,
  "enemy.quaternius.alpaking": 6,
  "enemy.quaternius.alpaking-evolved": 7,
  "enemy.quaternius.armabee": 8,
  "enemy.quaternius.armabee-evolved": 9,
  "enemy.quaternius.birb": 10,
  "enemy.quaternius.blue-demon": 11,
  "enemy.quaternius.bunny": 12,
  "enemy.quaternius.cactoro": 13,
  "enemy.quaternius.cactoro-high-detail": 14,
  "enemy.quaternius.cactoro-high-detail.boss": 15,
  "enemy.quaternius.cat": 16,
  "enemy.quaternius.chicken": 17,
  "enemy.quaternius.demon": 18,
  "enemy.quaternius.demon-high-detail": 19,
  "enemy.quaternius.demon-high-detail.elite": 20,
  "enemy.quaternius.dino": 21,
  "enemy.quaternius.dragon": 22,
  "enemy.quaternius.dragon-evolved": 23,
  "enemy.quaternius.fish": 24,
  "enemy.quaternius.fish-high-detail": 25,
  "enemy.quaternius.fish-high-detail.boss": 26,
  "enemy.quaternius.frog": 27,
  "enemy.quaternius.ghost": 28,
  "enemy.quaternius.ghost-skull": 29,
  "enemy.quaternius.glub": 30,
  "enemy.quaternius.glub-evolved": 31,
  "enemy.quaternius.goleling": 32,
  "enemy.quaternius.goleling-evolved": 33,
  "enemy.quaternius.green-blob": 34,
  "enemy.quaternius.green-spiky-blob": 35,
  "enemy.quaternius.hywirl": 36,
  "enemy.quaternius.monkroose": 37,
  "enemy.quaternius.mushnub": 38,
  "enemy.quaternius.mushnub-evolved": 39,
  "enemy.quaternius.mushroom-king": 40,
  "enemy.quaternius.ninja": 41,
  "enemy.quaternius.ninja-high-detail": 42,
  "enemy.quaternius.ninja-high-detail.boss": 43,
  "enemy.quaternius.orc": 44,
  "enemy.quaternius.orc-enemy": 45,
  "enemy.quaternius.pigeon": 46,
  "enemy.quaternius.pink-blob": 47,
  "enemy.quaternius.squidle": 48,
  "enemy.quaternius.tribal": 49,
  "enemy.quaternius.wizard": 50,
  "enemy.quaternius.yeti": 51,
  "enemy.quaternius.yeti-high-detail": 52,
  "enemy.quaternius.yeti-high-detail.elite": 53,
  "enemy.rammer": 54,
  "enemy.scrapBug": 55,
  "enemy.scrapBugHorde": 56,
  "enemy.testHound": 57
};
/** Exact runtime type for every enemy definition (generated from content). */
export const ENEMY_RUNTIME_TYPE_BY_DEF_ID: Readonly<Record<string, string>> = {
  "enemy.gunTower": "gunTower",
  "enemy.lootTruck": "lootTruck",
  "enemy.quaternius.alien": "monster",
  "enemy.quaternius.alien-high-detail": "monster",
  "enemy.quaternius.alien-high-detail.boss": "monster",
  "enemy.quaternius.alpaking": "monster",
  "enemy.quaternius.alpaking-evolved": "monster",
  "enemy.quaternius.armabee": "monster",
  "enemy.quaternius.armabee-evolved": "monster",
  "enemy.quaternius.birb": "monster",
  "enemy.quaternius.blue-demon": "monster",
  "enemy.quaternius.bunny": "monster",
  "enemy.quaternius.cactoro": "monster",
  "enemy.quaternius.cactoro-high-detail": "monster",
  "enemy.quaternius.cactoro-high-detail.boss": "monster",
  "enemy.quaternius.cat": "monster",
  "enemy.quaternius.chicken": "monster",
  "enemy.quaternius.demon": "monster",
  "enemy.quaternius.demon-high-detail": "monster",
  "enemy.quaternius.demon-high-detail.elite": "monster",
  "enemy.quaternius.dino": "monster",
  "enemy.quaternius.dragon": "monster",
  "enemy.quaternius.dragon-evolved": "monster",
  "enemy.quaternius.fish": "monster",
  "enemy.quaternius.fish-high-detail": "monster",
  "enemy.quaternius.fish-high-detail.boss": "monster",
  "enemy.quaternius.frog": "monster",
  "enemy.quaternius.ghost": "monster",
  "enemy.quaternius.ghost-skull": "monster",
  "enemy.quaternius.glub": "monster",
  "enemy.quaternius.glub-evolved": "monster",
  "enemy.quaternius.goleling": "monster",
  "enemy.quaternius.goleling-evolved": "monster",
  "enemy.quaternius.green-blob": "monster",
  "enemy.quaternius.green-spiky-blob": "monster",
  "enemy.quaternius.hywirl": "monster",
  "enemy.quaternius.monkroose": "monster",
  "enemy.quaternius.mushnub": "monster",
  "enemy.quaternius.mushnub-evolved": "monster",
  "enemy.quaternius.mushroom-king": "monster",
  "enemy.quaternius.ninja": "monster",
  "enemy.quaternius.ninja-high-detail": "monster",
  "enemy.quaternius.ninja-high-detail.boss": "monster",
  "enemy.quaternius.orc": "monster",
  "enemy.quaternius.orc-enemy": "monster",
  "enemy.quaternius.pigeon": "monster",
  "enemy.quaternius.pink-blob": "monster",
  "enemy.quaternius.squidle": "monster",
  "enemy.quaternius.tribal": "monster",
  "enemy.quaternius.wizard": "monster",
  "enemy.quaternius.yeti": "monster",
  "enemy.quaternius.yeti-high-detail": "monster",
  "enemy.quaternius.yeti-high-detail.elite": "monster",
  "enemy.rammer": "rammer",
  "enemy.scrapBug": "scrapBug",
  "enemy.scrapBugHorde": "scrapBug",
  "enemy.testHound": "scrapBug"
};
/** Stable authored formation-role order used by compact ownership encoding. */
export const ENEMY_FORMATION_ROLE_ORDER: readonly string[] = ["escort","guard","line","reinforcement","skirmisher","support","vanguard","wanderer"];
